import EntityType from "@mapmycustomers/shared/enum/EntityType";

import { EditorRouteStop } from "@app/scene/routes/store/routeDetails/types/RouteStop";

// Stops are keyed by their underlying entity id in the editor, not by the
// pivot id, because drafts may not yet have a pivot id.
const getEditorStopEntityId = (stop: EditorRouteStop): EditorRouteStop["id"] => {
  if (stop.entity === EntityType.COMPANY) {
    return stop.accountId;
  }
  if (stop.entity === EntityType.PERSON) {
    return stop.contactId;
  }
  return stop.id;
};

export default getEditorStopEntityId;
